module.exports = {
    api: {
        url: process.env.REACT_APP_API_END_POINT
    }
}
